import React, { useRef } from 'react';
import { Modal, Button, FormGroup, FormControl, ControlLabel, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import qs from 'qs';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';

const AddEditModal = ({ error, open, type, item, isLoading, isLoadingSubmit, methods, onSubmit, onHide }) => {
  const formNode = useRef(null);
  const selectMethod = useRef(null);

  const onShow = () => {
    if (!methods?.find((method) => method.id === item?.method_id) && type === 'edit') {
      selectMethod.current.value = '';
    }
  };

  const onSubmitForm = (event) => {
    event?.preventDefault();
    const current = formNode?.current;
    const data = new FormData(current);
    const payload = {};
    for (const name of data.keys()) {
      if (formNode.current?.[name]) {
        payload[name] = Number(formNode.current[name].value);
      }
    }
    const parsePayload = qs.parse(payload);
    onSubmit?.(type, parsePayload);
  };

  return (
    <Modal show={open} onHide={onHide} onShow={onShow} backdrop="static" className="modal-md-custom">
      <form ref={formNode} onSubmit={onSubmitForm}>
        <Modal.Header closeButton>
          <Modal.Title>{type === 'add' ? 'Add bonus' : 'Edit bonus'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert text={error} />}
          {isLoading ? (
            <div className="modal-loader-small" />
          ) : (
            <>
              <FormGroup>
                <ControlLabel htmlFor="amount">Bonus amount</ControlLabel>
                <InputGroup>
                  <FormControl type="number" name="amount" id="amount" min={0.01} step={0.01} max={100} defaultValue={item?.bonus || ' '} autoFocus />
                  <InputGroup.Addon>%</InputGroup.Addon>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <ControlLabel htmlFor="method">For method</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="method"
                  inputRef={(ref) => (selectMethod.current = ref)}
                  defaultValue={item?.method_id || ''}
                >
                  {methods?.map((method) => (
                    <option key={method?.id} value={method?.id}>
                      {method?.title}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
              <FormGroup>
                <ControlLabel htmlFor="deposit_from">Deposit from</ControlLabel>
                <FormControl type="number" name="deposit_from" id="deposit_from" defaultValue={item?.deposit_from || ''} min={0.01} step={0.01} />
              </FormGroup>
              <FormGroup>
                <ControlLabel htmlFor="status">Status</ControlLabel>
                <FormControl componentClass="select" placeholder="select" name="status" defaultValue={item?.status}>
                  <option value="1">Enabled</option>
                  <option value="0">Disabled</option>
                </FormControl>
              </FormGroup>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading}>
            {isLoadingSubmit && <Spinner />}
            <span>{type === 'add' ? 'Add bonus' : 'Save changes'}</span>
          </Button>
          <Button
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

AddEditModal.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  methods: PropTypes.array,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddEditModal;
